module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"doctors":"ექიმები","clinic_services":"კლინიკის სერვისები"}}')
  delete Component.options._Ctor
}
